import { render, staticRenderFns } from "./ConfirmationSettings.vue?vue&type=template&id=03ac3380&scoped=true"
import script from "./ConfirmationSettings.vue?vue&type=script&lang=js"
export * from "./ConfirmationSettings.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationSettings.vue?vue&type=style&index=0&id=03ac3380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ac3380",
  null
  
)

export default component.exports